module.exports = __webpack_public_path__ + "static/img/4.47f5f69.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/1/1/zh/4.png
// module id = u9Ka
// module chunks = 0